import * as React from 'react';

const FeetOnTableSmall = () => (
  <svg
    width={57}
    height={47}
    viewBox="0 0 57 47"
    strokeWidth={1}
    fillRule="evenodd"
    stroke="#1C1F34"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <polygon
      stroke="none"
      fill="#DEDEDE"
      points="21.872 44.142 24.341 44.142 24.341 41.674 21.872 41.674"
    />
    <polygon
      stroke="none"
      fill="#DEDEDE"
      points="5.641 44.142 8.109 44.142 8.109 41.674 5.641 41.674"
    />
    <path
      stroke="none"
      fill="#677BC5"
      d="M41.278,17.244 C41.278,17.244 36.201,17.407 36.998,26.312 L36.067,25.947 C36.067,25.947 31.629,27.793 34.477,35.411 C34.477,35.411 33.469,35.229 31.15,36.054 C28.832,36.879 27.215,37.509 25.427,36.054 C23.64,34.599 23.175,32.017 23.05,29.913 C22.925,27.809 22.539,25.975 20.327,21.485 C18.116,16.994 18.298,13.77 20.969,13.77 C23.64,13.77 23.869,16.319 23.869,16.319 C23.869,16.319 26.424,19.953 26.901,20.574 C27.378,21.195 27.909,20.969 28.241,19.406 C28.574,17.843 29.364,15.132 29.14,13.055 C28.917,10.977 27.907,5.752 28.657,3.906 C29.407,2.06 30.86,1.22 32.289,2.005 C33.717,2.789 33.51,5.409 33.51,5.409 L35.415,10.798 C35.415,10.798 39.533,15.682 41.278,17.244"
    />
    <path
      stroke="none"
      fill="#DEDEDE"
      d="M54.16,38.672 C53.225,38.177 52.276,37.589 51.337,36.926 C48.712,35.068 47.894,33.777 45.887,31.782 C43.627,29.534 41.674,27.592 39.611,26.498 C39.139,26.248 38.652,26.049 38.165,25.908 C37.781,25.797 37.375,26.024 37.264,26.417 C37.154,26.809 37.378,27.219 37.765,27.331 C38.157,27.444 38.552,27.606 38.937,27.81 C40.809,28.802 42.69,30.673 44.868,32.838 C46.916,34.875 47.779,36.211 50.505,38.139 C51.493,38.838 52.496,39.459 53.486,39.984 C53.594,40.041 53.709,40.068 53.823,40.068 C54.085,40.068 54.339,39.923 54.469,39.671 C54.655,39.308 54.517,38.862 54.16,38.672"
    />
    <path
      strokeWidth={2}
      d="M28.732,37.283 L28.732,37.283 L1.25,37.283 L1.25,37.283 C1.25,39.708 3.216,41.674 5.641,41.674 L24.341,41.674 C26.766,41.674 28.732,39.708 28.732,37.283 Z"
    />
    <path
      strokeWidth={2}
      d="M37.985,26.583 C30.693,24.31 27.378,21.195 27.378,21.195 L23.897,16.661 C23.897,16.661 23.898,14.175 21.681,13.803 C19.465,13.431 18.258,16.269 19.035,18.61 C19.813,20.95 23.056,26.029 23.029,28.804 C23.003,31.579 23.52,35.469 26.531,36.706 C29.541,37.942 31.144,34.7 36.107,35.533 C41.07,36.366 43.884,39.366 51.852,40.703"
    />
    <path
      strokeWidth={2}
      d="M37.984,26.571 C38.396,26.715 38.825,26.9 39.274,27.134 C43.099,29.131 45.828,32.701 51.458,36.312 C52.394,36.913 53.37,37.487 54.391,38.021"
    />
    <path
      strokeWidth={2}
      d="M55.555,24.994 C52.303,23.643 48.968,22.613 45.189,20.132 C37.916,15.359 35.415,10.798 35.415,10.798 L33.51,5.409 C33.51,5.409 34.28,2.544 32.288,1.504 C30.297,0.464 28.269,3.289 28.283,5.755 C28.298,8.221 29.809,14.055 28.924,16.685 C28.426,18.165 27.983,20.033 28.131,21.76"
    />
    <polygon
      stroke="none"
      fill="#677BC5"
      points="4.732 37.283 14.937 37.283 14.937 24.97 4.732 24.97"
    />
    <path stroke="#FFFFFF" d="M8.5,26 L8.5,29" />
    <polygon strokeWidth={2} points="4.732 37.283 14.937 37.283 14.937 24.97 4.732 24.97" />
    <path
      strokeWidth={2}
      d="M14.937,33.771 C17.518,33.771 18.389,31.522 18.389,28.941 C18.389,26.36 17.518,26.054 14.937,26.054"
    />
    <path
      stroke="none"
      fill="#FFFFFF"
      d="M9.402,31.515 L7.598,31.515 C7.268,31.515 7,31.263 7,30.952 L7,29.345 C7,29.187 7.07,29.037 7.193,28.93 L8.095,28.149 C8.324,27.95 8.676,27.95 8.905,28.149 L9.807,28.93 C9.93,29.037 10,29.187 10,29.345 L10,30.952 C10,31.263 9.732,31.515 9.402,31.515"
    />
    <path d="M7.958,21.484 C7.958,20.328 8.958,20.328 8.958,19.172 C8.958,18.015 7.958,18.015 7.958,16.858 C7.958,15.701 8.958,15.701 8.958,14.544" />
    <path d="M11.434,21.484 C11.434,20.328 12.248,20.328 12.248,19.172 C12.248,18.015 11.434,18.015 11.434,16.858" />
    <path d="M32.292,18.655 C32.292,18.655 31.61,19.614 31.963,20.777 C32.249,21.721 33.197,21.912 33.197,21.912" />
    <path d="M5.641,41.674 L5.155,46.611" />
    <path d="M8.555,41.674 L8.069,46.611" />
    <path d="M24.341,41.674 L24.827,46.611" />
    <path d="M21.427,41.674 L21.913,46.611" />
  </svg>
);

export default FeetOnTableSmall;



// WEBPACK FOOTER //
// ./src/assets/images/icons/feet-on-table-small.js